"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        list: {
            minWidth: 144,
            padding: '8px 0px',
        },
        action: {
            height: 'auto !important',
            padding: '0 !important',
        },
        container: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'flex-start',
            maxWidth: 400,
            minHeight: 40,
            overflow: 'hidden',
            padding: '0 24px',
            width: '100%',
        },
        section: {
            opacity: '0.7 !important',
        },
        icon: {
            marginRight: 16,
        },
        rightIcon: {
            flexShrink: 0,
            marginLeft: 'auto',
        },
        textContainer: {
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            padding: '12px 0',
        },
        textContainerWithRightIcon: {
            paddingRight: 16,
        },
    });
});
